'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.peripheral.list', [])
  .controller('PeripheralListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/peripheral/list/index.js